<template lang="html">
  <div id="neighbourhood-map" class="contained-height w-100">
    <div id="map" />
  </div>
</template>

<script>
/* global google, InfoBox, $ */
import { mapMutations } from 'vuex';

export default {
  name: 'neighbourhood-map',
  props: {
    ready: {
      type: Boolean,
      default: false
    },
    mapData: {
      type: Object,
      default: () => {}
    },
    poiList: {
      type: Array,
      default: () => []
    },
    filteredPoiList: {
      type: Array,
      default: () => []
    },
    selectedPoiId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mounted: false,
      map: null,
      mapCenter: null,
      markerList: [],
      projectMarker: null,
      markerIcons: {
        default: null,
        selected: null,
        project: null
      },
      infobox: null
    };
  },
  computed: {
    filteredMarkerList() {
      return this.markerList.filter(marker =>
        this.filteredPoiList.find(poi => poi.id === marker.id)
      );
    }
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady'
    }),
    initMap() {
      this.mapCenter =
        new google.maps.LatLng(
          this.mapData.center.lat, this.mapData.center.lng
        );
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: this.mapCenter,
        zoom: 15,
        styles: JSON.parse(this.mapData.style),
        minZoom: 13,
        maxZoom: 19,
        disableDefaultUI: true,
        gestureHandling: 'greedy'
      });
      this.initMarkers();
      this.setPageReady(true);
    },
    initMarkers() {
      this.markerList = [];
      this.markerIcons.default = {
        url: '/static/img/neigh-circle.png',
        size: new google.maps.Size(36, 36),
        scaledSize: new google.maps.Size(36, 36),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 18),
        labelOrigin: new google.maps.Point(18, 18)
      };

      this.markerIcons.selected = {
        url: '/static/img/neigh-circle.png',
        size: new google.maps.Size(36, 36),
        scaledSize: new google.maps.Size(36, 36),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 18),
        labelOrigin: new google.maps.Point(18, 18)
      };

      this.markerIcons.project = {
        url: '/static/img/project-marker-q.png',
        size: new google.maps.Size(173, 108),
        scaledSize: new google.maps.Size(173, 108),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(86.5, 108)
      };

      this.projectMarker = new google.maps.Marker({
        position: {
          lat: this.mapData.project.lat,
          lng: this.mapData.project.lng
        },
        map: this.map,
        icon: this.markerIcons.project,
      });

      this.poiList.forEach((poi) => {
        const marker = new google.maps.Marker({
          id: poi.id,
          position: { lat: parseFloat(poi.lat), lng: parseFloat(poi.lng) },
          map: this.map,
          icon: this.markerIcons.default,
          label: {
            text: poi.orderId,
            color: '#4C6B7F',
            fontSize: '17px',
            class: 'nbhMarker',
          },
          info: {
            name: poi.name,
            address: poi.address,
            type: poi.type,
            stars: poi.stars
          },
          distance: poi.travelTime.drive
        });
        marker.addListener('click', this.selectPoi.bind(this, poi));
        this.markerList.push(marker);
      });

      this.markerList.forEach((marker) => {
        marker.setVisible(false);
      });

      this.filteredMarkerList.forEach((marker) => {
        marker.setVisible(true);
      });
    },
    selectPoi(poi) {
      this.$emit('setSelectedPoiId', poi.id);
    },
    openInfoBox(marker) {
      const offset = new google.maps.Size(15, -30);

      const fullStar = '<i class="fas fa-star"></i>';
      const halfStar = '<i class="fas fa-star-half"></i>';

      let fullStarCount = Math.floor(marker.info.stars);

      let halfStarCount = 0;
      const decimal = Math.floor(10 * (marker.info.stars % fullStarCount));

      if (decimal >= 8) {
        fullStarCount += 1;
      } else if (decimal >= 2) {
        halfStarCount = 1;
      }

      let starHtml = '';

      for (let i = 0; i < fullStarCount; i += 1) {
        starHtml += fullStar;
      }

      if (halfStarCount === 1) {
        starHtml += halfStar;
      }

      const div = `
      <div class="infobox-container">
        <div class="marker-hint"><span class="marker-stars">${starHtml}</span> in
        <span class="marker-type">${marker.info.type}</span></div>
        <div class="marker-name pt-2 pb-1">${marker.info.name}</div>
        <div class="marker-address">${marker.info.address}</div>
      </div>;
      `;

      const ibOptions = {
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: offset,
        zIndex: null,
        boxStyle: {
          padding: '0px 0px 0px 0px',
          width: '250px',
          height: '20px'
        },
        closeBoxURL: '',
        infoBoxClearance: new google.maps.Size(0, 0),
        isHidden: false,
        pane: 'floatPane',
        enableEventPropagation: false,
        content: div
      };

      this.closeInfobox();
      this.infobox = new InfoBox(ibOptions);
      google.maps.event.addListener(this.infobox, 'domready', () => {
        $('.popup_container').addClass('active');
        $('.popup_close').click(this.closeInfobox);
      });
      this.infobox.open(this.map, marker);
    },
    closeInfobox() {
      if (this.infobox !== null) {
        $('.popup_container').removeClass('active');
        this.infobox.close();
      }
    },
    distanceInPx(marker1, marker2) {
      /* eslint-disable */
      const p1 = this.map.getProjection().fromLatLngToPoint(marker1.getPosition());
      const p2 = this.map.getProjection().fromLatLngToPoint(marker2.getPosition());

      const pixelSize = Math.pow(2, -this.map.getZoom());

      const d = Math.sqrt((p1.x-p2.x)*(p1.x-p2.x) + (p1.y-p2.y)*(p1.y-p2.y))/pixelSize;

      return d;
      /* eslint-enable */
    }
  },
  watch: {
    ready: {
      immediate: true,
      handler() {
        if (this.ready && this.mounted) {
          this.initMap();
        }
      }
    },
    selectedPoiId() {
      this.filteredMarkerList.forEach((marker) => {
        if (marker.id === this.selectedPoiId) {
          this.map.setZoom(20);
          // this.map.setZoom(this.map.getZoom() - 1);
          // if (marker.distance >= 5) {
          //   this.map.setZoom(15);
          // } else {
          //   this.map.setZoom(16);
          // }
          const listener = google.maps.event.addListener(this.map, 'idle', () => {
            // const midPoint =
            //   google.maps.geometry.spherical.interpolate(
            //     this.projectMarker.getPosition(),
            //     marker.getPosition(),
            //     0.5
            //   );
            //   this.map.panTo(midPoint);
            const bounds = new google.maps.LatLngBounds();
            bounds.extend(this.projectMarker.getPosition());
            bounds.extend(marker.getPosition());
            this.map.fitBounds(bounds, 100);
            this.map.panToBounds(bounds, 100);
            google.maps.event.removeListener(listener);
          });

          marker.setIcon(this.markerIcons.selected);
          marker.setZIndex(google.maps.Marker.MAX_ZINDEX);
          this.openInfoBox(marker);
        } else {
          marker.setIcon(this.markerIcons.default);
        }
      });
      if (this.selectedPoiId === '') {
        this.closeInfobox();
      }
    },
    filteredPoiList: {
      immediate: true,
        handler() {
        const bounds = new google.maps.LatLngBounds();
        if (this.mapCenter) {
          bounds.extend(new google.maps.LatLng(this.mapCenter.lat(), this.mapCenter.lng()));

          this.markerList.forEach((marker) => {
            marker.setVisible(false);
          });

          this.filteredMarkerList.forEach((marker) => {
            marker.setVisible(true);
            bounds.extend(marker.getPosition());
          });

          if (this.map) {
            this.map.fitBounds(bounds);
          }
        }
      }
    },

  },
  mounted() {
    if (this.ready) {
      this.initMap();
    } else {
      this.mounted = true;
    }
  }
};
</script>

<style lang="scss">
#map {
  height: calc(100% + 25px);
  width: 100%;
}

.nbhMarker {
  font-family: Scandia-Medium, sans-serif;
}

.infobox-container {
  font-family: Scandia-Regular, sans-serif;
  color: white;
  background: var(--action);
  padding: 10px 20px;
  text-align: left;
  border-radius: .25rem!important;

  .marker-stars {
    font-size: 0.5rem;
  }

  .marker-hint {
    line-height: 0.5rem;
  }

  .marker-address {
    font-size: 0.7rem;
  }

  .marker-name {
    font-family: Scandia-Regular, sans-serif;
    font-size: 1.2rem;
    line-height: 1.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NeighbourhoodPage/NeighbourhoodMap/NeighbourhoodMap.vue